import React, { useState } from "react";
import { CircularProgress, colors, makeStyles } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import Grid from "@material-ui/core/Grid";
import { Box } from "@material-ui/core";
import * as Yup from "yup";

import { FormikHelpers, useFormik } from "formik";
import ExpandedContent from "../../../../../components/ExpandedContent";
import { InputField } from "../../../../../../../components/input-field/InputField";
import { DefaultButton } from "../../../../../components/Buttons";
import ICIPAdminService from "../../../../../../../services/ICIPAdminService";

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

interface PushNotificationProps {}

const useStyles = makeStyles(
  (theme) => ({
    gridContent: {
      padding: "0 8px",
    },
    textarea: {
      width: "100%",
      height: "200px",
      border: `1px solid ${defaultBorder(theme)}`,
      outline: 0,
      padding: "14px",

      "&:hover": {
        border: `1px solid ${defaultBorder(theme)}`,
        outline: 0,
      },
    },
    error: {
      fontSize: 13,
      color: colors.red[700],
      textAlign: "left",
    },
  }),
  { name: "icip-raffle-draw-push-notification", flip: null }
);

export const PushNotification = (props: PushNotificationProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const [smsApi, setSmsApi] = useState("");

  const resetForm = (formikInstance: any) => {
    formikInstance.resetForm();
  };

  const formik = useFormik({
    initialValues: { topic: "raw_notification", push_content: "" },
    validationSchema: Yup.object().shape({}),
    onSubmit: async (
      values: any,
      { setErrors, setSubmitting }: FormikHelpers<any>
    ) => {
      console.dir(smsApi);
      let formData = { ...values };

      try {
        const response = await ICIPAdminService.sendPushNotification(formData);
        setSubmitting(false);

        if (response.isSuccess) {
          switch (response.data.code) {
            case 100: // Ok
              resetForm(formik);
              break;
            case 150:
              // Validation error
              setErrors(JSON.parse(JSON.stringify(response.data.data)));
              break;
            default:
              setErrors({ error: response.data.message });
              break;
          }
        } else {
          setErrors({
            unknown: intl.formatMessage({ id: "error.unknownError" }),
          });
        }
      } catch (error) {
        setSubmitting(false);
        setErrors({
          unknown: intl.formatMessage({ id: "error.unknownError" }),
        });
      }
    },
  });

  const sendNotification = () => {
    formik.submitForm().then((e) => {});
  };

  const genericError = (formikInstance: any) => {
    if (formikInstance.errors.unknown) {
      return formikInstance.errors.unknown as string;
    }

    if (formikInstance.errors.push_content) {
      return formikInstance.errors.push_content as string;
    }

    if (formikInstance.errors.error) {
      return formikInstance.errors.error as string;
    }

    return "";
  };

  return (
    <>
      <Grid container spacing={6} className={classes.gridContent}>
        <Grid item sm={8}>
          <Box component="div" mb={2}>
            <InputField
              fullWidth
              id="topic"
              name="topic"
              label="Topic"
              placeholder=""
              type="text"
              value={formik.values.topic}
              onChange={formik.handleChange}
              error={
                Boolean(formik.touched.topic) && Boolean(formik.errors.topic)
              }
              helperText={formik.touched.topic && formik.errors.topic}
            />
          </Box>
          <textarea
            className={classes.textarea}
            id="push_content"
            name="push_content"
            placeholder={intl.formatMessage({
              id: "sharedScreen.pushContent",
            })}
            value={formik.values.push_content}
            onChange={formik.handleChange}
          />
        </Grid>
        <Grid item sm={4}>
          <Box mb={1} mt={4} mr={3}>
            <Box mb={1}>
              <DefaultButton
                fullWidth
                disabled={formik.isSubmitting}
                onClick={(_) => sendNotification()}
              >
                <FormattedMessage id="sharedScreen.sendNotification" />
              </DefaultButton>
            </Box>
          </Box>
          {formik.isSubmitting ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress color="secondary" size={26} thickness={4} />
            </Box>
          ) : (
            <></>
          )}

          <Box mt={2} component="div" className={classes.error}>
            {genericError(formik)}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
